import EventCard from './EventCard'
export * from './EventCard'

export default EventCard
